import { instance } from '@rsos/sinatra';
import { getAPIHost } from '@rsos/utils/metaTags';

export const getGISServices = orgName =>
  instance.get(`${getAPIHost()}/v1/capstone/psaps/${orgName}/gis-services`, {
    headers: { retry: true },
  });
